import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

function dm_c_14_perk_cards() {

    $('.c14-swiper').each(function(index) {
        const $container = $(this);
        const $swiperContainer = $container.closest('.container-fluid');
        const $prevButton = $swiperContainer.find('.swiper-button-prev');
        const $nextButton = $swiperContainer.find('.swiper-button-next');
        const $counter = $swiperContainer.find('.swiper-counter');

        // Utilities
        const isUnderLg = () => window.matchMedia('(max-width: 1023.98px)').matches;
        const getOriginalSlideCount = () => $container.find('.swiper-slide').not('.swiper-slide-duplicate').length;
        const setControlsVisibility = () => {
            const total = getOriginalSlideCount();
            const show = isUnderLg() ? true : total > 3; // Always show under LG; on LG+ only if > 3
            const $controls = $prevButton.add($nextButton).add($counter);
            // Handle Bootstrap's d-none if present, and inline display as fallback
            $controls.each(function() {
                const $el = $(this);
                if (show) {
                    $el.removeClass('d-none');
                    $el.show();
                } else {
                    $el.addClass('d-none');
                    $el.hide();
                }
            });
        };

        if ($prevButton.length && $nextButton.length) {
            $prevButton.addClass(`c14-swiper-button-prev-${index}`);
            $nextButton.addClass(`c14-swiper-button-next-${index}`);

            const swiper = new Swiper(this, {
                modules: [Navigation],
                slidesPerView: 1,
                spaceBetween: 30,
                autoHeight: true,
                speed: 1000,
                loop: false,
                navigation: {
                    nextEl: `.c14-swiper-button-next-${index}`,
                    prevEl: `.c14-swiper-button-prev-${index}`,
                },
                breakpoints: {
                    768: {
                        slidesPerView: 2,
                    },
                    1024: {
                        autoHeight: false,
                        slidesPerView: 3,
                    },
                },
                on: {
                    init: function(swiperInstance) {
                        let totalSlides = parseInt($counter.data('total'), 10);
                        if (isNaN(totalSlides) || !totalSlides) {
                            totalSlides = getOriginalSlideCount();
                        }
                        $counter.find('span').eq(0).text(swiperInstance.realIndex + 1);
                        $counter.find('span').eq(2).text(totalSlides);
                        setControlsVisibility();
                        const mql = window.matchMedia('(max-width: 1023.98px)');
                        const handler = () => setControlsVisibility();
                        if (typeof mql.addEventListener === 'function') {
                            mql.addEventListener('change', handler);
                        } else if (typeof mql.addListener === 'function') {
                            mql.addListener(handler);
                        }
                    },
                    slideChange: function(swiperInstance) {
                        const realIndex = swiperInstance.realIndex;
                        $counter.find('span').eq(0).text(realIndex + 1);
                    }
                }
            });
        } else {
            console.warn(`Navigation buttons not found for Swiper instance ${index}`);
        }
    });
}

export { dm_c_14_perk_cards };
